<template>
  <!-- 본문 영역 시작-->
  <div id="contract_container">
    <div class="contract_contents">
      <div class="contract1b_area_1">
        <img v-if="type=='contract'" src="../../assets/img/pass4.png" alt="가입">
        <img v-else src="../../assets/img/pass6.png" alt="해지">
        <h2>인증번호 입력</h2>
        <h3>휴대폰으로 전송된 인증번호를 입력하시면 완료됩니다.</h3>

        <v-form v-model="valid" ref="form" onsubmit="return false;">
          <table>
            <tr>
              <td class="certTd">
                <label for="certNum">인증번호</label>
              </td>
              <td style="text-align: center;">

                <v-text-field v-if="teleCoCd=='3'"
                  style="font-size: 0.75rem; width: 60%; padding-top:5px; vertical-align: middle;"
                  ref="certNum"
                  label="인증번호 입력"
                  mask="########"
                  :rules="rules.certNumLgTRules"
                  single-line
                  color="accent"
                  v-model="certNum"
                  required
                ></v-text-field>
                <v-text-field v-else
                  style="font-size: 0.75rem; width: 60%; padding-top:5px; vertical-align: middle;"
                  ref="certNum"
                  label="인증번호 입력"
                  mask="#####"
                  :rules="rules.certNumRules"
                  single-line
                  color="accent"
                  v-model="certNum"
                  required
                ></v-text-field>
                <div style="width: 30%; text-align: left">
                  <span style="font-size: 0.75rem">{{countdown}} </span>
                  <a class="reSend" style="font-size: 0.75rem; border: 1px solid #20c997; color: #dc3545; padding: 3px;" @click.stop="sendSmsCert">재전송</a>
                </div>
              </td>
            </tr>
          </table>
          <div class="contract1a_area_2" style="border: hidden">
          <p class="cf">
            <span class="para_space bottom_sub_content">-</span>
            <span class="para_space2 bottom_sub_content">인증번호를 3분 이내에 입력하셔야 합니다.</span>
          </p>
          <p class="cf">
            <span class="para_space bottom_sub_content">-</span>
            <span class="para_space2 bottom_sub_content">인증시간이 초과하면 재전송 버튼을 눌러주시기 바랍니다.</span>
          </p>
          </div>
          <div class="form_btn">
            <v-btn
              id="back_btn"
              style="color:#fff; font-size:16px margin-left: 0px !improtant"
              color="#007bff"
              @click.stop="submit()"
            >확인</v-btn>
            <v-btn
              id="back_btn"
              style="color:#fff; font-size:16px margin-left: 0px !improtant"
              color="#dc3545"
              @click.stop="$router.go(-1)"
            >돌아가기</v-btn>
          </div>
        </v-form>
      </div>
    </div>
    <!-- 인증번호 인증 실패시 팝업 시작-->
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline"></v-card-title>
          <v-card-text style="text-align:center;">인증번호를 확인하세요.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click.native="dialog = false">확인</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- 인증번호 인증 실패시 팝업 끝-->
    <!-- 처리 프로그레스 시작-->
    <v-layout row justify-center>
      <v-dialog v-model="progressDialog" persistent max-width="100" > 
        <v-card>
          <v-progress-linear color="#0046dc" :indeterminate="true" style="margin:auto 0px; color:red;"></v-progress-linear>
          <!-- </div> -->
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- 처리 프로그레스 끝-->
    <!-- 처리결과 다이얼로그 시작 -->
    <v-layout row justify-center>
      <v-dialog v-model="resultDialog" persistent max-width="290">
        <!-- <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn> -->
        <v-card>
          <v-card-title class="headline"></v-card-title>
          <v-card-text style="text-align:center;">정상적으로 처리되지 않았습니다.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="green darken-1" text @click.native="dialog = false">Disagree</v-btn> -->
            <v-btn color="green darken-1" text @click.stop="goNext()">확인</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- 처리결과 다이얼로그 끝 -->
    <!-- router Param 없을때 시작 -->
    <v-layout row justify-center>
      <v-dialog v-model="returnDialog" persistent max-width="290">
        <!-- <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn> -->
        <v-card>
          <v-card-title class="headline"></v-card-title>
          <v-card-text style="text-align:center;">정상적인 접근이 아닙니다.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="green darken-1" text @click.native="dialog = false">Disagree</v-btn> -->
            <v-btn color="green darken-1" text @click.stop="goReturn()">확인</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- router Param 없을때 끝 -->
    <!-- 시간제한 지났을때 시작 -->
    <v-layout row justify-center>
      <v-dialog v-model="countDownOverDialog" persistent max-width="290">
        <!-- <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn> -->
        <v-card>
          <v-card-title class="headline"></v-card-title>
          <v-card-text style="text-align:center;">인증시간이 초과했습니다.<br/> 재전송 버튼을 눌러주시기 바랍니다.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="green darken-1" text @click.native="dialog = false">Disagree</v-btn> -->
            <v-btn color="green darken-1" text @click.stop="countDownOverDialog = !countDownOverDialog">확인</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- 시간제한 지났을때 끝 -->
  </div>
</template>

<script>
import {GaTracking} from "@/mixins/index.js";
import { CONSTANS } from '@/const/index.js';

export default {
  mixins: [GaTracking],
  name: "app",
  data: () => ({
    //routeParams
    valid: false,
    type: "", //: "contract", teleCoCd: "2", cellTelNo: "12312312312"
    teleCoCd: "",
    cellTelNo: "",
    birth: "",
    genCd: "",
    name: "",
    certNum: "",
    prdtNo: "A001",
    agreeYn: false,
    ansuranceAgreeYn: false,
    formHasErrors: false, // validation
    dialog: false,
    progressDialog: false,
    resultDialog : false,
    returnDialog : false,
    countDownOverDialog: false,
    rules: { 
      requiredCertNum: value => !!value || "인증번호를 입력하세요.",
      certNumRules: [
        v => !!v || "인증번호를 입력하세요.",
        v =>
          (v &&
            v.length >= 5 &&
            /([0-9]{5})$/.test(v)) ||
          "인증번호가 정확하지 않습니다."
      ],
      certNumLgTRules: [
        v => !!v || "인증번호를 입력하세요.",
        v =>
          (v &&
            (v.length >= 8 ||v.length == 5) &&
            /([0-9]{5})|([0-9]{8})$/.test(v)) ||
          "인증번호가 정확하지 않습니다."
      ]
    },
    //timer
    countdown: "3:00",
    endTime: "",
    hours: "",
    mins: "",
    msLeft: "",
    time: ""
  }),
  created() {
    // console.log("router", this.$router.name);
    // console.log("$route", this.$route.params);
    this.type = this.$route.params.type;
    this.teleCoCd = this.$route.params.teleCoCd;
    this.cellTelNo = this.$route.params.cellTelNo;
    this.birth = this.$route.params.birth;
    this.genCd = this.$route.params.genCd;
    this.name = this.$route.params.name;
    this.agreeYn = this.$route.params.agreeYn;
    this.ansuranceAgreeYn = this.$route.params.ansuranceAgreeYn;
    this.mvnoYn = this.$route.params.mvnoYn;
    if(this.type == undefined){
      this.returnDialog = true
    }
  },
  mounted() {
    // console.log("aasdasd");
    this.sendSmsCert(null);
  },
  methods: {
    sendSmsCert(e) {
      if(e != undefined && e != null){
        this.gaTracking(e);
      }
      // console.log("sendSmsCert");
      
      if(this.teleCoCd == "1") {
          this.prdtNo = "A001";
      } else if(this.teleCoCd == "2") {
          this.prdtNo = "A003";
      } else if(this.teleCoCd == "3") {
          this.prdtNo = "A002";
      }
      const apiUrl = (this.teleCoCd === CONSTANS.TELE_CO_CD.KT) ? `${process.env.VUE_APP_KT_BM_API_URI}/rest/sendSmsCert` : '/rest/sendSmsCert';

      this.axios
        .post(apiUrl, {
          type: this.type,
          teleCoCd: this.teleCoCd,
          cellTelNo: this.cellTelNo,
          prdtNo: this.prdtNo,
        })
        .then(result => {
          // console.log(result);
          // this.posts.push(result.data)
          this.posts = result.data;
          this.countdowns("countdown", 3, 0);
        })
        .catch(result => {
          // console.log("ERROR ", result);
          //this.countdowns("countdown", 3, 0);
        });
    },
    submit() {
      
      this.$refs.form.validate();
      if (!this.valid) {
        return false;
      }
      this.progressDialog = true;
      

      if(this.countdown === "0:00"){
        this.progressDialog = false;
        this.countDownOverDialog = true;
        return false;
      } 
      
      //this.progressDialog = false;
      
      // this.formHasErrors = false;
      // Object.keys(this.form).forEach(f => {
      //   if (!this.form[f]) {
      //     this.formHasErrors = true;
      //     this.$refs[f].validate(true);
      //   }
      // });
      // if (this.formHasErrors) {
      //   this.progressDialog = false;
      //   return false;
      // }

      // 가입 / 해지
      this.axios
        .post("/rest/chanCust", {
          type: this.type,
          teleCoCd: this.teleCoCd,
          cellTelNo: this.cellTelNo,
          birth: this.birth,
          genCd: this.genCd,
          name: this.name,
          certNum: this.certNum,
          prdtNo: this.prdtNo,
          agreeYn: this.agreeYn,
          ansuranceAgreeYn: this.ansuranceAgreeYn,
          mvnoYn: this.mvnoYn,
        })
        .then(result => {
          this.progressDialog = false;
          // console.log(result);
          // console.log(result.data.resultCd);
          if (result.data.resultCd === "S0000") {
            this.$router.push({
              name: "passSafeGuardResult",
              params: { type: this.type, result: "SUCCESS" }
            });
          } else if (result.data.resultCd === "E9990") {
            this.dialog = true;
          } else {
            this.goNext()
          }
        })
        .catch(result => {
          this.progressDialog = false;
          // this.resultDialog = true;
          //this.dialog = true;
          // console.log("ERROR ", result.resultCd)
          this.goNext()
          //this.$router.push({name:'passSafeGuardResult', params:{type:this.type, result:"FAIL"}})
        });
    },
    goNext() {
      this.resultDialog = false;
      this.$router.push({name:'passSafeGuardResult', params:{type:this.type, result:"FAIL"}})
    },
    goReturn(){
      this.$router.push({name:'passSafeguardCs'})
    },
    countdowns(elementName, minutes, seconds) {
      this.minutes = minutes;
      this.seconds = seconds;
      this.endTime =
        +new Date() + 1000 * (60 * this.minutes + this.seconds) + 500;
      this.updateTimer();
    },
    updateTimer() {
      this.msLeft = this.endTime - +new Date();
      if (this.msLeft < 1000) {
        this.countdown = "0:00";
      } else {
        this.time = new Date(this.msLeft);
        this.hours = this.time.getUTCHours();
        this.mins = this.time.getUTCMinutes();
        this.countdown =
          (this.hours
            ? this.hours + ":" + this.twoDigits(this.mins)
            : this.mins) +
          ":" +
          this.twoDigits(this.time.getUTCSeconds());
        setTimeout(this.updateTimer, this.time.getUTCMilliseconds() + 500);
      }
    },
    twoDigits(n) {
      return n <= 9 ? "0" + n : n;
    }
  },
  computed: {
    form() {
      return {
        certNum: this.certNum
      };
    }
  }
};
</script>

<style>
/* validation check color red */
.v-messages__message {
  color: #ff5252 !important;
}
.v-input__control,
.v-input__slot,
.v-select__slot {
  color: #005df9 !important;
}
</style>
